<!-- Error Banner -->
@if (error) {
  <div class="fixed top-4 right-4 bg-red-100 dark:bg-red-950/60 border border-red-400 dark:border-red-800 text-red-700 dark:text-red-200 px-4 py-3 rounded shadow-lg z-[100] max-w-md">
    <div class="flex items-start">
      <div class="flex-1">
        <p class="font-bold">Error</p>
        <p class="text-sm">{{error}}</p>
      </div>
      <button (click)="chatState.setError(null)" class="ml-4 text-red-700 dark:text-red-200 hover:text-red-900 dark:hover:text-white">✕</button>
    </div>
  </div>
}

<!-- Success Banner -->
@if (successMessage) {
  <div class="fixed top-4 right-4 bg-green-100 dark:bg-green-950/60 border border-green-400 dark:border-green-800 text-green-700 dark:text-green-200 px-4 py-3 rounded shadow-lg z-[100] max-w-md">
    <div class="flex items-start">
      <div class="flex-1">
        <p class="font-bold">Success</p>
        <p class="text-sm">{{successMessage}}</p>
      </div>
      <button (click)="chatState.setSuccessMessage(null)" class="ml-4 text-green-700 dark:text-green-200 hover:text-green-900 dark:hover:text-white">✕</button>
    </div>
  </div>
}
